import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_CANDIDATE_JOB_APPLY_EXPORT_BY_JOBUUID } from "../../../common/URLs";

export const fetchEmployerCandidateJobApplyExportbyStatus = async (status = 'shortlist') => {
    try {
        // Ensure status is properly extracted
        const statusValue = typeof status === 'object' ? status?.status || 'shortlist' : status;

        // Construct URL with status query parameter
        const url = new URL(`${BASE_URL}/${EMPLOYER}/${EMPLOYER_CANDIDATE_JOB_APPLY_EXPORT_BY_JOBUUID}`);
        url.searchParams.append('status', statusValue);

        const token = await fetchToken();

        // console.log('API URL:', url.toString());
        // console.log('Token:', token ? 'Token exists' : 'No token found');

        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(url.toString(), {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            // Add this if your API requires cookies
        });

        // console.log('Response status:', response.status);

        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
                // console.log('Error response data:', errorData);
            } catch (e) {
                console.warn('Failed to parse error response:', e);
            }

            const errorMessage = errorData?.message ||
                errorData?.response ||
                `Server Error: ${response.status} ${response.statusText}`;

            throw new Error(errorMessage);
        }

        const data = await response.json();
        // console.log('API Response:', data);

        if (!data) {
            throw new Error('No data received from server');
        }

        return data;

    } catch (error) {
        console.error("Error in fetchEmployerCandidateJobApplyExportbyStatus:", error);
        throw error; // Re-throw to let the thunk handle it
    }
};